import Api from "../../../util/Api";

export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Új hatásvizsgálat',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newRow'
            }
        ],
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToGrid'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetForm'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyRow'
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow'
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteRow'
            }
        ],
        searchFields: [
            {
                name: "dataManagementDescription",
                label: "Adatkezelés leírása",
                formSize: 3,
                formVisible: true,
                formType: 'text'
            },
            {
                name: "dataManagementGoal",
                label: "Adatkezelés célja",
                formSize: 3,
                formVisible: true,
                formType: 'text'
            },
            {
                name: "conductCode",
                label: "Magatartási kódex előírásai",
                formSize: 3,
                formVisible: true,
                formType: 'text'
            },
        ],
        headerFields: [
            {
                name: "id",
                label: "ID",
                visibility: false,
                formVisible: false
            },
            {
                name: "siteId",
                label: "Telephely ID",
                visibility: false,
                formVisible: false
            },
            {
                name: "dataManagementDescription",
                label: "Adatkezelés leírása",
                sort: true,
                visibility: true,
                formType: 'text',
                formSize: 3,
                formRequired: true,
                formVisible: true
            },
            {
                name: "dataManagementGoal",
                label: "Adatkezelés célja",
                sort: true,
                visibility: true,
                formType: 'text',
                formSize: 3,
                formRequired: true,
                formVisible: true
            },
            {
                name: "pleas",
                label: "Jogalap",
                visibility: false,
                formSize: 3,
                formRequired: true,
                formVisible: true,
                formType: 'checkboxes',
                checkboxesOptions: {
                    apiCallback: Api.getPleaFilter,
                    formatOption: function (val) {
                        return val.pleaName;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'pleaName',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "legitimateInterest",
                label: "Jogos érdek",
                visibility: false,
                formType: 'text',
                formSize: 3,
                formRequired: true,
                formVisible: true
            },
            {
                name: "recipients",
                label: "Címzettek",
                visibility: false,
                formType: 'text',
                formSize: 3,
                formRequired: true,
                formVisible: true
            },
            {
                name: "dataManagementProcessStartDate",
                label: "Adatkezelési folyamat tervezett kezdő dátuma",
                visibility: false,
                formType: 'date',
                formSize: 3,
                formRequired: true,
                formVisible: true
            },
            {
                name: "dataHandlings",
                label: "Tervezett adatkezelés időtartam",
                visibility: false,
                formSize: 3,
                formRequired: true,
                formVisible: true,
                formType: 'checkboxes',
                checkboxesOptions: {
                    apiCallback: Api.getImpactAssessmentDataHandlingFilter,
                    formatOption: function (val) {
                        return val.dataHandling;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'dataHandling',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "managementTools",
                label: "Adatkezeléshez használt eszközök",
                visibility: false,
                formSize: 3,
                formRequired: true,
                formVisible: true,
                formType: 'checkboxes',
                checkboxesOptions: {
                    apiCallback: Api.getImpactAssessmentDataManagementToolFilter,
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "conductCode",
                label: "Magatartási kódex előírásai",
                sort: true,
                visibility: true,
                formType: 'text',
                formSize: 4,
                formRequired: true,
                formVisible: true
            },
            {
                name: "privacyOfficerOpinion",
                label: "Adatvédelmi tisztviselő véleménye",
                visibility: false,
                formType: 'text',
                formSize: 4,
                formRequired: true,
                formVisible: true
            },

            {
                name: "proportionalityTest",
                label: "Szükségesség arányosság vizsgálatára",
                visibility: false,
                formType: 'text',
                formSize: 4,
                formRequired: true,
                formVisible: true
            },
            {
                name: "riskAnalysis",
                label: "Kockázat elemzés",
                visibility: false,
                formType: 'text',
                formSize: 4,
                formRequired: true,
                formVisible: true
            },
            {
                name: "riskManagement",
                label: "Kockázat kezelés",
                visibility: false,
                formType: 'text',
                formSize: 4,
                formRequired: true,
                formVisible: true
            },
            {
                name: "dataManagementOpinion",
                label: "Érintettek véleménye az adatkezelésről",
                visibility: false,
                formType: 'text',
                formSize: 4,
                formRequired: true,
                formVisible: true
            },
            {
                name: "docName",
                label: "Dokumentum megnevezés",
                visibility: false,
                formType: 'text',
                formSize: 4,
                formRequired: false,
                formVisible: true
            },
            {
                name: "docPlace",
                label: "Dokumentum helye",
                visibility: false,
                formType: 'text',
                formSize: 4,
                formRequired: false,
                formVisible: true
            },
            {
                name: "docExpiration",
                label: "Dokumentum hatályossága",
                visibility: false,
                formType: 'text',
                formSize: 4,
                formRequired: false,
                formVisible: true
            },
            {
                name: "conductCodeOrIso",
                label: "Csatlakozott magatartási kódex vagy ISO szabványhoz",
                visibility: false,
                formType: 'checkbox',
                formSize: 12,
                formVisible: true
            },
            {
                name: "createdBy",
                label: "Készítő",
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedBy",
                label: "Módosító",
                visibility: false,
                formVisible: false
            },
            {
                name: "createdOn",
                label: "Készítés dátuma",
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedOn",
                label: "Módosítás dátuma",
                visibility: false,
                formVisible: false
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            },
        ]
    }
}
